/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUserDetails } from 'actions/userDetailsAction';
import FSBModal from 'components/common/FSBModal';
import UserDetails from './components/UserDetails';

const UserDetailsDrawer = () => {
  const dispatch = useDispatch();
  const { status, selectedUser } = useSelector(
    (state) => state.userDetailsReducer,
  );

  const drawerToggle = () => {
    dispatch(setUserDetails({ status: false, selectedUser: null }));
  };
  useEffect(() => {
    dispatch(setUserDetails({ status: false, selectedUser: null }));
  }, []);

  window.addEventListener('popstate', () => {
    drawerToggle();
  });

  return (
    <div>
      {' '}
      {status && (
        <FSBModal
          open={status}
          size="xl"
          title="User Details"
          closeButtonLabel=""
          confirmButtonLabel=""
          message=""
          toggleAlert={drawerToggle}
          onClose={drawerToggle}
          onConfirmClick={drawerToggle}
          modalClass=""
        >
          <UserDetails userId={selectedUser?.id} />
        </FSBModal>
      )}
    </div>
  );
};

export default UserDetailsDrawer;
